import { BaseEntityModel } from "../baseEntityModel";
import api, { TipoOptions } from '../api';


export interface CrfRegistroEsin204 extends BaseEntityModel {
    relatorioNarrativa: string;
    relatorioEsp: string;
    relatorioFornecedorNomeAjustado: string;
    relatorioAprop: string;
    relatorioUn: string;
    relatorioTipo: string;
    relatorioSerie: string;
    relatorioDocumento: string;
    relatorioFornecedorNumero: string;
    relatorioFornecedorNome: string;
    relatorioNatOper: string;
    contratoPcs: string;
    relatorioQuantidade: number;
    relatorioOrdemCompra: string;
    relatorioOrdemCompraInt: number;
    relatorioItemDescricao: string;
    relatorioMovimento: string;
    relatorioParaOi: string;
    relatorioNumOi: string;
    relatorioIcmsPercentual: number;
    relatorioIcms: number;
    telaDesconsiderarAnoMotivo: string;
    telaDesconsiderarAno: boolean;
    telaVerbaRemanescenteProvisao: boolean;
    telaReclassificacaoProximoMes: boolean;
    telaRemanescenteProvisao: boolean;
    crfTipoExecutadoAnoMesId: string | null;
    fornecedorId: string | null;
    crfEsin204Id: string;
    crfContaContabilCcId: string | null;
    mensagemProcessoConsolidarExecutado: string;
}

export interface CrfRegistroEsin204Importacao extends BaseEntityModel {
    mensagemProcessoConsolidarExecutado: string;
    statusProcessamentoLinha: string;
    statusProcessoConsolidarExecutado: boolean;
    importacaoContaCtbl: string
    importacaoDescricaoConta: string
    importacaoReferencia: string
    importacaoProcesso: string
    importacaoHistorico: string
    importacaoDataMovto: string
    dataMovto: Date
    importacaoDc: string
    importacaoQuantidade: number
    importacaoValorMovto: number
    importacaoValorMovtoEmDolar: number
    importacaoDocumento: string
    importacaoUsuario: string
    importacaoOrdManut: string
    importacaoTipoManut: string
    importacaoTipoDeTipoManut: string
    importacaoCodEqpto: string
    importacaoTAg: string
    importacaoContaOrigem: string
    importacaoContaDespesaOp: string
    importacaoEmitente: string // Fornecedor
    importacaoDescricaoDoEmitente: string //NomeFornecedor
    importacaoItem: string
    importacaoNumOc: number
    importacaoDataConfOC: string
    importacaoOrigemDataOc: string
    importacaoRequisitanteOc: string
    importacaoOrdemInvest: string
    importacaoDivisaoArea: string
    importacaoDescricaoDaDivisaoArea: string
    importacaoNumContrato: number
    importacaoNumPedido: string
    importacaoObservacao: string
    importacaoTipoAprop: string
    telaDesconsiderarAno: boolean
    telaVerbaRemanescenteProvisao: boolean
    telaDesconsiderarAnoMotivo: string;
    telaAlteracao: boolean;
    fornecedorMrn: string;
    itemAlterado: boolean;
}


export enum AlteracaoEsin204 {
    importacaoNumOc,
    importacaoNumContrato,
    telaVerbaRemanescenteProvisao,
    telaDesconsiderarAno,
    telaDesconsiderarAnoMotivo
}

export interface UpdatRegistroEsin204 {
    crfEsin204Id: string,
    importacaoNumOc?: number;
    importacaoNumContrato?: number;
    telaVerbaRemanescenteProvisao: boolean;
    telaDesconsiderarAno: boolean;
    telaDesconsiderarAnoMotivo?: string;
}

export const getAllRegistroCrfEsin204ByEsin204Id = (crfEsin204Id: string, ehContaResultado: boolean) => {
    return api.get<CrfRegistroEsin204Importacao[]>(`crfRegistroEsin204/getAllRegistroEsin204ByCrfEsin204Id/${crfEsin204Id}/${ehContaResultado}`);
}

export const consolidarExecutado = (crfEsin204Id: string, ehContaResultado: boolean) => {
    return api.post<CrfRegistroEsin204Importacao[]>(`crfEsin204/consolidarExecutado`, { 'crfEsin204Id': crfEsin204Id, 'ehContaResultado': ehContaResultado });
}

export const salvarAlteracaoEsin204 = (listResult: Array<UpdatRegistroEsin204>) => {
    const from = { Itens: listResult };
    return api.put(`crfEsin204/salvarAlteracaoEsin204`, from);
}

export const habilitarEdicaoCrfEsin204 = (crfEsin204Id: string) => {
    const from = { crfEsin204Id: crfEsin204Id };
    return api.put(`crfEsin204/habilitarEdicao`, from);
}

export const getStatusFiltro = () => {

    const arrayStatusProcesso: Array<TipoOptions> = [];
    arrayStatusProcesso.push({ text: 'Sucesso', value: 'Sucesso' } as TipoOptions);
    arrayStatusProcesso.push({ text: 'Erro', value: 'Erro' } as TipoOptions);
    arrayStatusProcesso.push({ text: 'Pendente Processamento', value: 'Pendente Processamento' } as TipoOptions);

    return arrayStatusProcesso;
}